module.exports = __webpack_public_path__ + "img/x7.b8bf570d.jpg";